import { DownOutlineIcon } from '@carboncopyco/icons';
import { Button } from '@carboncopyco/ui';

type ShowAllButtonProps = {
  setShowAll: (showAll: boolean) => void;
  itemsCount: number;
};

export const ShowAllButton = ({
  setShowAll,
  itemsCount,
}: ShowAllButtonProps) => {
  return (
    <div className="flex items-center p-2 mt-auto">
      <Button
        blue
        link
        label={`Load more (${itemsCount})`}
        rightIcon={<DownOutlineIcon />}
        onClick={() => setShowAll(true)}
      />
    </div>
  );
};
